// The one door on Recharts (TODO §15/§2.4), mirroring `gantt-engine.ts` and
// `diagram-engine.ts`.
//
// §2.4 **Lazy.** Recharts is not small — the library plus its d3 scale/shape/path
// dependencies is a few hundred KB — and a deck with no chart must download none of it. So
// nothing imports `ChartCanvas` statically: not the block, not the right panel, not the
// export pass. `webpack.config.js` already sets `splitChunks: { chunks: "all" }`, so the
// dynamic import below falls out as its own chunk with no config change. **Verify that from
// the built asset list rather than from intent** — the same instruction §26/§16.11 gives, for
// the same reason: a stray static import anywhere silently folds the chunk back into main.
//
// §2.4 **One import specifier.** Every caller goes through `loadChartCanvas`, so the chunk is
// fetched once and shared: `React.lazy` in `ChartBlock`, the panel's preview, and the
// imperative `collectChartSvgs` on the HTML export path all resolve the same module instance.

export type ChartCanvasModule = typeof import("@/components/deck/ChartCanvas");

let modulePromise: Promise<ChartCanvasModule> | null = null;

export function loadChartCanvas(): Promise<ChartCanvasModule> {
  if (!modulePromise) {
    modulePromise = import("@/components/deck/ChartCanvas");
  }
  return modulePromise;
}

// Has the chunk already been fetched? The thumbnail capturer asks before deciding a slide is
// ready to rasterize (§8.6) — a chart captured while its chunk is still in flight bakes the
// Suspense fallback into the cache, and nothing would ever invalidate it.
export function isChartCanvasLoaded(): boolean {
  return modulePromise !== null;
}
